import MainRouter from "./MainRouter";

export default function Main(){
    return (
        <div>
            <MainRouter/>
        </div>
    );
}